import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
    useAppStore,
    useTVStore,
    useVODStore,
    useVisibilityStore,
} from '@/shared/store'

import useVisibleContent from '@/pages/mainScreen/model/useVisibleContent'
import { useComponentsRender } from '@/app/context/ComponentsRenderContext/ComponentsRenderContext'
import { getFromLocalStorage } from '@/shared/localStorage/localStorageRepository'
import { IS_COOKIES_ACCEPTED, settingsPagePath } from '@/shared/constants'
import { useHandleContentWithLinkParams } from '@/shared/hooks'

export const useMainScreenLogic = () => {
    const { isComponentsReadyToRender } = useComponentsRender()
    const { devicesLimitExceeded } = useAppStore()
    const { setActualContentVisible } = useVisibleContent()
    const { pathname } = useLocation()
    const navigate = useNavigate()
    const {
        isVodContentVisible,
        isTvContentVisible,
        setSettingsContentVisible,
    } = useVisibilityStore()
    const { isPIPMode, setSelectedChannel } = useTVStore()
    const { isVodContentPlaying } = useVODStore()
    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => {
        setOpenModal(false)
    }

    useEffect(() => {
        setActualContentVisible(pathname)
    }, [isComponentsReadyToRender, pathname])

    useEffect(() => {
        setSelectedChannel(null)
        const isCookiesFromLocalStorage =
            getFromLocalStorage(IS_COOKIES_ACCEPTED)

        if (!isCookiesFromLocalStorage) {
            setOpenModal(true)
        }
    }, [])

    useEffect(() => {
        if (devicesLimitExceeded && pathname !== settingsPagePath) {
            setSettingsContentVisible()
            navigate(settingsPagePath, { replace: true })
        }
    }, [devicesLimitExceeded, pathname])

    const isTVisible = isPIPMode ? true : isTvContentVisible

    useHandleContentWithLinkParams()

    return {
        openModal,
        handleClose,
        pathname,
        isComponentsReadyToRender,
        isTVisible,
        isVodContentVisible,
        isVodContentPlaying,
    }
}
